import { createSlice } from '@reduxjs/toolkit';
import { APIStatus } from '@application/enums/api-status';
import { generatePassportOtpAsync, verifyPassportOtpAsync, fetchFamilyFestPassportsAsync, fetchPassportAuditLogsAsync } from './familyFestPassportThunk';
const initialState = {
    status: APIStatus.IDLE,
    otpGenerated: false,
    verifyStatus: APIStatus.IDLE,
    isOtpVerified: false,
    isNdaConfirmed: false,
    passports: null,
    auditLogs: null
};
export const familyFestPassportSlice = createSlice({
    name: 'familyFestPassport',
    initialState,
    reducers: {
        resetPassportStatus: (state) => {
            state.status = APIStatus.IDLE;
            state.apiError = undefined;
        },
        resetVerifyStatus: (state) => {
            state.verifyStatus = APIStatus.IDLE;
            state.apiError = undefined;
        },
        confirmNda: (state) => {
            state.isNdaConfirmed = true;
        },
        resetVerification: (state) => {
            state.isOtpVerified = false;
            state.isNdaConfirmed = false;
            state.otpGenerated = false;
            state.verifyStatus = APIStatus.IDLE;
            sessionStorage.removeItem('OTPId');
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(generatePassportOtpAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(generatePassportOtpAsync.fulfilled, (state) => {
            state.status = APIStatus.SUCCESS;
            state.otpGenerated = true;
        })
            .addCase(generatePassportOtpAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        })
            .addCase(verifyPassportOtpAsync.pending, (state) => {
            state.verifyStatus = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(verifyPassportOtpAsync.fulfilled, (state, action) => {
            state.verifyStatus = APIStatus.SUCCESS;
            state.isOtpVerified = action.payload.isSuccess;
        })
            .addCase(verifyPassportOtpAsync.rejected, (state, action) => {
            state.verifyStatus = APIStatus.FAILED;
            state.apiError = action.payload;
        })
            .addCase(fetchFamilyFestPassportsAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(fetchFamilyFestPassportsAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.passports = action.payload;
        })
            .addCase(fetchFamilyFestPassportsAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        })
            .addCase(fetchPassportAuditLogsAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(fetchPassportAuditLogsAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.auditLogs = action.payload;
        })
            .addCase(fetchPassportAuditLogsAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
    }
});
export const { resetPassportStatus, resetVerifyStatus, confirmNda, resetVerification } = familyFestPassportSlice.actions;
export default familyFestPassportSlice.reducer;
